import type { CandidatePatient } from '~/lib/types/reassignment';

export const isPatientEligible = (patient: CandidatePatient): boolean =>
  !patient.hasPendingReassignment || patient.failureReason !== null;

export const getProviderTypeLabel = (
  provider: {
    providerTypeDetails?: { name?: string };
    providerTypeName?: string;
  } | null,
): string =>
  provider?.providerTypeDetails?.name ?? provider?.providerTypeName ?? '';
